import { AsyncThunk, SerializedError } from "@reduxjs/toolkit";
import { IAPIError } from "shared/types";
import { IAPIState, IPagination } from "./general";
import { IJSONAPIItem, IJSONAPIType } from "./jsonApi";

export enum IDataKeys {
  userVenues = "userVenues",
  searchVenues = "searchVenues",
  venue = "venue",
  stage = "stage",
  stageCapacity = "stageCapacity",
  equipment = "equipment",
  stageEquipment = "stageEquipment",
  venueInfoBlock = "venueInfoBlock",
  stageInfoBlock = "stageInfoBlock",
  contact = "contact",
  place = "place",
  file = "file",
  image = "image",
  venueInvite = "venueInvite",
  userBands = "userBands",
  adminBands = "adminBands",
  bands = "bands",
  band = "band",
  bandUser = "bandUser",
  myBandUsers = "myBandUsers",
  bandUserWithPermissions = "bandUserWithPermissions",
  user = "user",
  userAddress = "userAddress",
  userPhoneNumber = "userPhoneNumber",
  userEmergencyContact = "userEmergencyContact",
  userHomeBase = "userHomeBase",
  userPassport = "userPassport",
  userTravelVisa = "userTravelVisa",
  userSocialSecurityForm = "userSocialSecurityForm",
  userDrivingPermit = "userDrivingPermit",
  userVehicle = "userVehicle",
  userLoyaltyProgram = "userLoyaltyProgram",
  addresses = "addresses",
  phoneNumbers = "phoneNumbers",
  eventTypes = "eventTypes",
  eventTicketAndPassTypes = "eventTicketAndPassTypes",
  eventInfoBlockTypes = "eventInfoBlockTypes",
  memberCategories = "memberCategories",
  event = "event",
  calendar = "calendar",
  userCompanies = "userCompanies",
  company = "company",
  invoice = "invoice",
  companyInvoices = "companyInvoices",
  companySubscriptions = "companySubscriptions",
  subscriptionRequest = "subscriptionRequest",
  subscription = "subscription",
  subscriptions = "subscriptions",
  customSubscriptionRequest = "customSubscriptionRequest",
  bandInvitation = "bandInvitation",
  pendingBandInvitation = "pendingBandInvitation",
  sentBandInvitation = "sentBandInvitation",
  eventPeopleBlock = "eventPeopleBlock",
  eventPeopleBlockUser = "eventPeopleBlockUser",
  eventPeopleBlockUserRsvp = "eventPeopleBlockUserRsvp",
  eventScheduleBlock = "eventScheduleBlock",
  eventScheduleTimesheetEntry = "eventScheduleTimesheetEntry",
  eventInfoBlock = "eventInfoBlock",
  permissionType = "permissionType",
  permissionGroup = "permissionGroup",
  permission = "permission",
  groupUserPermissions = "groupUserPermissions",
  eventVenueBlock = "eventVenueBlock",
  eventGuestListBlock = "eventGuestListBlock",
  eventGuestListTicketAndPassType = "eventGuestListTicketAndPassType",
  eventGuestListBlockEntry = "eventGuestListBlockEntry",
  eventTravelBlock = "eventTravelBlock",
  eventFlightTravelLeg = "eventFlightTravelLeg",
  eventBusTravelLeg = "eventBusTravelLeg",
  eventTrainTravelLeg = "eventTrainTravelLeg",
  eventOtherTravelLeg = "eventOtherTravelLeg",
  eventSuggestedLocation = "eventSuggestedLocation",
  eventGoogleLocation = "eventGoogleLocation",
  eventTravelBlockPassenger = "eventTravelBlockPassenger",
  eventTravelBookingTicket = "eventTravelBookingTicket",
  ical = "ical",
  eventAccommodationBlock = "eventAccommodationBlock",
  eventAccommodationRoom = "eventAccommodationRoom",
  eventAccommodationPeople = "eventAccommodationPeople",
  scheduledFlight = "scheduledFlight",
  eventAccommodationRoomType = "eventAccommodationRoomType",
  eventAccommodationReservation = "eventAccommodationReservation",
  eventDetailsExport = "eventDetailsExport",
  lastGuestlistSent = "lastGuestlistSent",
  lastEventDetailsExportSent = "lastEventDetailsExportSent",
  paymentInfo = "paymentInfo",
  eventsExportConfig = "eventsExportConfig",
  eventsExport = "eventsExport",
  userApiKey = "userApiKey",
}

export type EnumKeys = keyof typeof IDataKeys;

export interface IPaginationItem extends IPagination {
  itemsPerPage?: number;
  totalItems?: number;
  pages?: { [key: number]: string[] }; // array of IDs for that page
}

export interface IMetaItem extends Partial<IJSONAPIItem> {
  createdItem?: IJSONAPIItem;
  api?: {
    status: IAPIState;
    error?: StateErrorType;
  };
}

export interface IDataState {
  data: { [key in EnumKeys]?: IJSONAPIType };
  meta?: {
    [key: string]: IMetaItem;
  };
  pagination?: { [key: string]: IPaginationItem };
}

export enum IActionStates {
  pending = "pending",
  rejected = "rejected",
  fulfilled = "fulfilled",
}

type GenericAsyncThunk = AsyncThunk<any, any, any>;
export type PendingAction = ReturnType<
  GenericAsyncThunk[IActionStates.pending]
>;
export type RejectedAction = ReturnType<
  GenericAsyncThunk[IActionStates.rejected]
>;
export type FulfilledAction = ReturnType<
  GenericAsyncThunk[IActionStates.fulfilled]
>;

export type StateErrorType = (IAPIError & SerializedError) | null;
